import React from "react";
import useTgkFormAmountSourcePanel from "./TgkFormAmountSourcePanelHook";
import { TgkAmountObjectSource } from "../../interfaces/CoObject";
import { DbApplicationDropDown } from "../DbApplicationDropdown";
import { IComboBoxOption } from "@fluentui/react";
import { FormDropDown } from "../co-dropdown-panel/form-drop-down/FormDropDown";
import { DropDownSheet } from "../co-dropdown-panel/drop-down-sheet/DropDownSheet";
import { ObjectPanelTabs } from "../co-panel/ObjectPanelComponent";
import { TextField } from "@fluentui/react/lib/TextField";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";

export interface TgkFormAmountSourceProps {
  isEdit?: boolean;
  objectSource: TgkAmountObjectSource;
  updateSource: (obj: TgkAmountObjectSource, tabValid, modified: boolean) => void;
  validateSource: (obj: TgkAmountObjectSource) => ObjectPanelTabs;
  selectDBAndFetchDefaultRoots: (option: IComboBoxOption) => void;
  isFileExcelExisting?: boolean;
  isComponentInstance?: boolean;
  isLocked?: boolean;
}

export const TgkFormAmountSourcePanel = (props: TgkFormAmountSourceProps) => {
  const {
    objectSource,
    onFormClick,
    selectSheetComboBox,
    initAreas,
    sheetsAreaChartMap,
    cellInput,
    setCell,
    selectDBAndFetchDefaultRoots,
    isFileExcelExisting,
    isComponentInstance,
    isLocked,
  } = useTgkFormAmountSourcePanel(props);

  return (
    <>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <DbApplicationDropDown
          disabled={isComponentInstance || isLocked}
          dbApplication={objectSource?.dbApplication}
          selectDbComboBox={selectDBAndFetchDefaultRoots}
        />
      </div>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <FormDropDown
          form={objectSource.form}
          dbApplication={objectSource.dbApplication}
          onFormClick={onFormClick}
          isComponentInstance={isComponentInstance}
        />
      </div>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <DropDownSheet
          isEdit={props.isEdit}
          sheet={objectSource.sheet}
          form={objectSource.form}
          dbApplication={objectSource.dbApplication}
          selectSheetComboBox={selectSheetComboBox}
          initAreas={initAreas}
          type={"AMOUNT"}
          objectSource={objectSource.objectSource}
          sheetsAreaChartMap={sheetsAreaChartMap}
          isFileExcelExisting={isFileExcelExisting}
          isComponentInstance={isComponentInstance}
        />
      </div>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <TextField
          id="cell_edit"
          label={formatMessage(`cof.objectsource.amount.excelpanel.selectcell`)}
          required
          value={cellInput}
          onChange={setCell}
          disabled={objectSource.sheet == null || !isFileExcelExisting || isComponentInstance || isLocked}
        />
      </div>
    </>
  );
};
